export const GROUPS = ['Super User', 'Internal User'] as const
